import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-host',
  templateUrl: './host.component.html',
  styleUrls: ['./host.component.css']
})
export class HostComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  
  gotoGettingStarted(): void {
    this.router.navigate([`/cinejoy/screening-parties/getting-started`]);
  }
}
